var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1",
    transform: "translate(-1349.000000, -877.000000)",
    fill: "#1D2B7D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1336.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,13 C22.8284271,13 23.5,14.0073593 23.5,15.25 L23.5,20.5 L28.75,20.5 C29.9926407,20.5 31,21.1715729 31,22 C31,22.8284271 29.9926407,23.5 28.75,23.5 L23.5,23.5 L23.5,28.75 C23.5,29.9926407 22.8284271,31 22,31 C21.1715729,31 20.5,29.9926407 20.5,28.75 L20.5,23.5 L15.25,23.5 C14.0073593,23.5 13,22.8284271 13,22 C13,21.1715729 14.0073593,20.5 15.25,20.5 L20.5,20.5 L20.5,15.25 C20.5,14.0073593 21.1715729,13 22,13 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/Zoom_in.c25075833b5eeceecd26f2c6b2fd33c3.svg";
export { ForwardRef as ReactComponent };